/*
*
* BackupPos Api
*
* @version 1.0.0
* @author Paolo Pastacaldi
* @since 19-Aug-2025
*/

import { axiosInstance as axios } from 'Api'
import { handlingResponse } from 'Utility/globalMethods'

if (process.env.ISMOCK === 'true') {
  try {
    require('Mocks/backupPos/backupPos')
  } catch (error) {
    console.error('Error loading BackupPos mock:', error)
  }
}
export async function getBackupPosInfo (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/marketing-service/posbackup/info',
      params: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getShopsList (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/marketing-service/posbackup/list',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method

export async function getProductsList ({ abiCode, terminalCode }) {
  let data
  try {
    data = await axios({
      method: 'get',
      url: '/services/marketing-service/posbackup/products/list',
      params: { abiCode, terminalCode }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getOrders (params) {
  let data
  try {
    data = await axios({
      method: 'get',
      url: '/services/marketing-service/posbackup/orders',
      params: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function submitBackupPosActivation (params) {
  let data
  try {
    data = await axios({
      method: 'post',
      url: '/services/marketing-service/posbackup/submit',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method
